import { render, staticRenderFns } from "./picker-shop.vue?vue&type=template&id=fb2b5324"
import script from "./picker-shop.vue?vue&type=script&lang=js"
export * from "./picker-shop.vue?vue&type=script&lang=js"
import style0 from "./picker-shop.vue?vue&type=style&index=0&id=fb2b5324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports